
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire78ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire78ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

parcelRequire("1qHQF");

var $04Pik = parcelRequire("04Pik");

var $jj8gv = parcelRequire("jj8gv");

var $15KYv = parcelRequire("15KYv");
const $b8226df118621c3f$var$genreEl = document.querySelector(".hero__wrapper--genre");
const $b8226df118621c3f$var$genreBtnEl = document.querySelector(".category");
let $b8226df118621c3f$var$active\u0421urrentBtnEl = $b8226df118621c3f$var$genreBtnEl.querySelector(".category__btn.active");
(0, $04Pik.fetchGenre)("liebe").then((data)=>{
    const obj_book = [];
    data.map((el)=>obj_book.push(new (0, $15KYv.objBook)(el)));
    $b8226df118621c3f$var$genreEl.innerHTML = (0, $jj8gv.renderBooks)(data, "genre", true, false, obj_book);
    obj_book.forEach((element)=>element.addEvent());
}).catch((error)=>{
    $b8226df118621c3f$var$genreEl.innerHTML = `<p style="align-self:center;margin:0 auto;text-align:center;color:var(--secondary-text-color);">OOPS... <br />
We are very sorry!<br />
We have lost the results from the server, please reload the page</p>`;
});
$b8226df118621c3f$var$genreBtnEl.addEventListener("click", $b8226df118621c3f$var$renderCategory);
function $b8226df118621c3f$var$renderCategory(e) {
    if (e.target.nodeName !== "BUTTON") return;
    $b8226df118621c3f$var$active\u0421urrentBtnEl.classList.remove("active");
    const activeNewBtnEl = e.target;
    activeNewBtnEl.classList.add("active");
    $b8226df118621c3f$var$active\u0421urrentBtnEl = activeNewBtnEl;
    $b8226df118621c3f$var$genreEl.innerHTML = "";
    (0, $04Pik.fetchGenre)(e.target.getAttribute("data-name")).then((data)=>{
        const obj_book = [];
        data.map((el)=>obj_book.push(new (0, $15KYv.objBook)(el)));
        $b8226df118621c3f$var$genreEl.innerHTML = (0, $jj8gv.renderBooks)(data, "genre", true, false, obj_book);
        obj_book.forEach((element)=>element.addEvent());
    }).catch((error)=>{
        $b8226df118621c3f$var$genreEl.innerHTML = `<p style="align-self:center;margin:0 auto;text-align:center;color:var(--secondary-text-color);">OOPS... <br />
We are very sorry!<br />
We have lost the results from the server, please reload the page</p>`;
    });
}



var $04Pik = parcelRequire("04Pik");

var $6mMsB = parcelRequire("6mMsB");

var $fb9GJ = parcelRequire("fb9GJ");

const $c0e91f642909ff4d$var$container = document.getElementById("pagination");
const $c0e91f642909ff4d$var$options = {
    totalItems: 198,
    itemsPerPage: 33,
    visiblePages: 6,
    page: 1,
    centerAlign: false,
    firstItemClassName: "tui-first-child",
    lastItemClassName: "tui-last-child",
    template: {
        page: '<a href="#" class="tui-page-btn">{{page}}</a>',
        currentPage: '<strong class="tui-page-btn tui-is-selected">{{page}}</strong>',
        moveButton: '<a href="#" class="tui-page-btn tui-{{type}}"><span class="tui-ico-{{type}}">{{type}}</span></a>',
        disabledMoveButton: '<span class="tui-page-btn tui-is-disabled tui-{{type}}"><span class="tui-ico-{{type}}">{{type}}</span></span>',
        moreButton: '<a href="#" class="tui-page-btn tui-{{type}}-is-ellip"><span class="tui-ico-ellip">...</span></a>'
    }
};
const $c0e91f642909ff4d$export$22fa394f3ba39578 = new (0, (/*@__PURE__*/$parcel$interopDefault($fb9GJ)))($c0e91f642909ff4d$var$container, $c0e91f642909ff4d$var$options);



var $jj8gv = parcelRequire("jj8gv");
const $cffaf4ec50868483$var$catalogEl = document.querySelector(".sect-catalog__wrapper");
const $cffaf4ec50868483$var$catalogInput = document.querySelector(".sect-catalog__input");
const $cffaf4ec50868483$var$catalogSubmit = document.querySelector(".sect-catalog__submit");
let $cffaf4ec50868483$var$search = "liebe";
$cffaf4ec50868483$var$catalogEl.innerHTML = "";
(0, $04Pik.fetchCatalog)($cffaf4ec50868483$var$search).then((data)=>{
    $cffaf4ec50868483$var$catalogEl.innerHTML = (0, $jj8gv.renderBooks)(data, "catalog");
}).catch((error)=>{
    $cffaf4ec50868483$var$catalogEl.innerHTML = `<p style="text-align:center;color: var(--secondary-text-color);">OOPS... <br />
We are very sorry!</p>`;
});
$cffaf4ec50868483$var$catalogSubmit.addEventListener("click", $cffaf4ec50868483$var$renderCatalog);
$cffaf4ec50868483$var$catalogInput.addEventListener("submit", $cffaf4ec50868483$var$renderCatalog);
function $cffaf4ec50868483$var$renderCatalog(e) {
    e.preventDefault();
    $cffaf4ec50868483$var$search = `${$cffaf4ec50868483$var$catalogInput.value.split(" ").join("+")}`;
    $cffaf4ec50868483$var$catalogEl.innerHTML = "";
    (0, $04Pik.fetchCatalog)($cffaf4ec50868483$var$search).then((data)=>{
        $cffaf4ec50868483$var$catalogEl.innerHTML = (0, $jj8gv.renderBooks)(data, "catalog");
        (0, $c0e91f642909ff4d$export$22fa394f3ba39578).reset();
    }).catch((error)=>{
        $cffaf4ec50868483$var$catalogEl.innerHTML = `<p style="text-align:center;color: var(--secondary-text-color);">OOPS... <br />
We are very sorry!<br />
We don\u{2019}t have any results matching your search.</p>`;
    });
}
$cffaf4ec50868483$var$catalogEl.addEventListener("click", (0, $6mMsB.modalShow));
(0, $c0e91f642909ff4d$export$22fa394f3ba39578).on("afterMove", (event)=>{
    let num = (event.page - 1) * 33;
    $cffaf4ec50868483$var$catalogEl.innerHTML = "";
    (0, $04Pik.fetchCatalog)($cffaf4ec50868483$var$search, num).then((data)=>{
        $cffaf4ec50868483$var$catalogEl.innerHTML = (0, $jj8gv.renderBooks)(data, "catalog");
    }).catch((error)=>{
        $cffaf4ec50868483$var$catalogEl.innerHTML = `<p style="text-align:center;color: var(--secondary-text-color);">OOPS... <br />
We are very sorry!<br />
We don\u{2019}t have any results matching your search.</p>`;
    });
    window.scrollTo({
        top: $cffaf4ec50868483$var$catalogInput.getBoundingClientRect().y,
        left: 0,
        behavior: "smooth"
    });
});


parcelRequire("8QdEj");



//# sourceMappingURL=catalog.9e8f944d.js.map
